export default "__VITE_ASSET__3a67ea2c__"